<template>
  <div style="background-color:#061b26; text-align:center; padding:50px 0;">
    <svg
      :height="radius * 2"
      :width="radius * 2"
     >
  <defs>
    <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
      <stop offset="0%" stop-color="#00bc9b" />
      <stop offset="100%" stop-color="#5eaefd" />
    </linearGradient>
  </defs>
  <filter id="blurMe">
    <feGaussianBlur in="SourceGraphic" stdDeviation="1" />
  </filter>
       <circle
         stroke="#082637"
         :stroke-width="stroke"
         fill="none"
         :r="normalizedRadius"
         :cx="radius"
         :cy="radius"
      />
      <circle
         stroke="url(#gradient)"
         :stroke-dasharray="circumference + ' ' + circumference"
         :style="{ strokeDashoffset: strokeDashoffset }"
         :stroke-width="stroke"
         fill="transparent"
         :r="normalizedRadius"
         :cx="radius"
         :cy="radius"
         filter="url(#blurMe)"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'progress-ring',
  props: {
    radius: String,
    progress: Number,
    stroke: String
  },
  data() {
    const normalizedRadius = this.radius - this.stroke * 2;
    const circumference = normalizedRadius * 2 * Math.PI;

    return {
      normalizedRadius,
      circumference
    };
  },
  computed: {
    strokeDashoffset() {
      return this.circumference - this.progress / 100 * this.circumference;
    }
  },
}
</script>
<style>
circle {
  transition: stroke-dashoffset 0.35s;
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
}
</style>
